import React, {useMemo, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import CommercialTable from '../../../../common/components/commercialTable/commercialTable';
import {DefaultColumnFilter} from '../../../../manageOrders/components/internalCommons/TableFilters';
import {Checkbox, Button, Icon, Input, Modal, Loader} from 'semantic-ui-react';
import {vehTypeSpecials} from '../../../constants/selectTypes';
import {Actions} from '../../../../common/actions';

const {saveLogisticObservation} = Actions;

export const PriorizationDateTable = ({
  dataTable,
  selectMode,
  setFilteredTableData,
  columnsTable,
  userType,
  updateMyData,
  dropDownValueBill,
}) => {
  const {loading} = useSelector((state) => state.priorizationDates);
  const [showObservationModal, setShowObservationModal] = useState(false);
  const [logisticObservation, setLogisticObservation] = useState('');
  const [vehicleSelected, setVehicleSelected] = useState();
  const data = useMemo(() => dataTable, [dataTable]);
  const columns = useMemo(() => columnsTable, [selectMode, userType]);

  const dispatch = useDispatch();

  const showLogisticObservationModal = (lineComment, chassis) => {
    setShowObservationModal(true);
    setLogisticObservation(lineComment);
    setVehicleSelected(chassis);
  };

  const closeModal = () => {
    setLogisticObservation('');
    setShowObservationModal(false);
  };

  const saveLogisticModalObservation = (e) => {
    e.preventDefault();
    dispatch(saveLogisticObservation({'data': {
      'chassis': vehicleSelected,
      'comments': logisticObservation,
    }}, closeModal));
  };

  const changeLogisticObservation = (e, input) => {
    e.preventDefault();
    setLogisticObservation(input.value.toUpperCase() || '');
  };

  const customColumnsHook = (columns, i) => [
    ...columns.map((column, i) => {
      if (column.id === 'isSelected') {
        return {
          ...column,
          'title': 'selectionColumn',
          'Cell': ({row, column, value, ...rest}) => {
            return (
              <Checkbox
                checked={value}
                onChange={(e, data) => updateMyData(row.index, column.id, data.checked, row)}
              />
            );
          },
        };
      }
      if (column.id === 'comments') {
        return {
          ...column,
          'Cell': ({row}) => (
            <div className='flex row center'>
              <div className='priorization-table-observations' title={row.original.comments || ''}>
                {row.original.comments}
              </div>
              <Button icon={<Icon className='add' />} style={{'padding': '2px', 'marginLeft': '5px'}}
                onClick={(e) => (showLogisticObservationModal(row.original.comments, row.original.chassis))}
                disabled={dropDownValueBill === 'facturados'}
              />
            </div>
          ),
        };
      }
      return column;
    }),
  ];

  return (
    <>
      <CommercialTable
        columns={columns}
        data={data}
        tableStyles='priorization-dates-table-wrapper'
        tableType='fixed'
        tableWrapperStyles='priorization-dates-table-wrapper'
        isSmallCell={true}
        fixedColumns={selectMode ? [30, 50, 80, 170, 230, 50] : [50, 80, 170, 230, 50]}
        defaultColumnFilter={DefaultColumnFilter}
        setFilteredData={setFilteredTableData}
        updateMyData={updateMyData}
        customColumnsHook={customColumnsHook}
        colorLineByProperty={{'key': 'vehType', 'values': vehTypeSpecials,
          'rgbColor': '#d4d4d5'}}
      />
      <Modal open={showObservationModal}
        header='Observación Logística'
        content={
          <div className='flex' style={{'padding': '2em'}}>
            <Input fluid value={logisticObservation} className='flex grow'
              onChange={(e, input) => changeLogisticObservation(e, input)} />
            {loading ?
              <Loader active inline='centered' /> :
              <>
                <Button icon={<Icon name='save' className='save' size='big' />}
                  color='primary' style={{'marginLeft': '1em'}}
                  onClick={(e) => saveLogisticModalObservation(e)} />
                <Button style={{'marginLeft': '1em'}} icon={<Icon name='close' className='close flex middle center' />}
                  onClick={() => closeModal()} />
              </>
            }
          </div>
        } closeOnEscape={true} />
    </>
  );
};
